export const ENTITY_ROUTE_PATHS = {
  BANK_ACCOUNT: '/accounting/bank-accounts/',
  COST_CENTER: '/accounting/cost-center/',
  PARTNER_PRIVATE: '/partners-new/private/',
  PARTNER_CORPORATE: '/partners-new/corporate/',
  EMPLOYEE_PROFILE: '/team/employee-profile/',
  VAT_REPORT: '/accounting/vat-reports/',
  PRODUCT_VIEW: '/products/product-view/',
  STOCKTAKING_PROCESS: '/warehouse/stocktaking/process/',
  REPORTING_PERIOD_REPORT: '/accounting/reporting-periods/report/',
};
